
import DateRangeSlider from "@/components/DateRangeSlider.vue";
import Loader from "@/components/Loader.vue";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({ components: { Loader, DateRangeSlider } })
export default class Parameter extends Vue {
  @Prop({ required: true })
  id!: string;

  @Prop({ default: null })
  rownum!: number | null;

  dateRange = ["", ""];
  param: any = null;

  get defaultRules(): ((v: any) => boolean | string)[] {
    return [v => !!v || "Erforderliche Angabe"];
  }

  get from() {
    return this.dateRange[0];
  }

  get to() {
    return this.dateRange[1];
  }

  get paramWhere() {
    return this.rownum
      ? ["messst_nr=" + this.id, "rownum<" + this.rownum]
      : ["messst_nr=" + this.id];
  }

  get baseWhere() {
    return this.param
      ? [
          "messst_nr=" + this.id,
          "stoff_nr=" + this.param.stoff_nr,
          "einheit_nr=" + this.param.einheit_nr
        ]
      : [];
  }

  get where() {
    if (!this.param || !this.from || !this.to) {
      return [];
    }
    return [
      ...this.baseWhere,
      "ana_datum>=isodate:" + this.from,
      "ana_datum<=isodate:" + this.to
    ];
  }

  emit() {
    this.$emit("input", this.where);
  }

  onParameterDatenLoaded(params: any[]) {
    if (!this.param && params.length > 0) {
      // set default value to first entry
      this.param = params[0];
      console.log("Parameter: " + this.$route.query.param);
      if (
        this.$route.query.param &&
        typeof this.$route.query.param == "string"
      ) {
        const param = this.$route.query.param;
        for (let i = 0; i < params.length; i++) {
          if (String(params[i].stoff_nr).startsWith(param)) {
            this.param = params[i];
            break;
          }
        }
      }
    }
  }
}
